import { Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import Api from "../../../api";
import API_URL from "../../../api/url";
import { AbhaServices } from "../../../redux/Services";
import ReportFilter from "./reportFilter";
import moment from "moment";
import dayjs from "dayjs";
import { AbhaLinkedNotify } from "../../../redux/Services/AbhaLinkded";
import { GetLoggedInUser, encryptedData } from "../../../utils";
const ReportList = () => {
  const [FilteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const permission = usePermission("HIP Dashboard", "List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let LOG_IN_USER = GetLoggedInUser();
  const abhaCreatedList = useSelector(
    (state) => state.abhaCreated.ReportList || []
  );
  // const totalFaq = useSelector(state => state.faq.totalFaq || "");
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [limit, setLimit] = useState(10);
  // const { mutate: getabhaReportList, isLoading } = useMutation((data) =>
  //   dispatch(AbhaServices.ReportList(data, limit, page))
  // );
  const { mutate: Notify, isLoading: addLoading } = useMutation((data) =>
    dispatch(AbhaLinkedNotify(data, navigate))
  );
  const totalAbhaReportsLogs = useSelector(
    (state) => state.abhaCreated.totalAbhaReportsLogs || ""
  );
  const [raw, setRaw] = useState({});
  const [ModalNotify, setModalNotify] = useState(false);
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const [pdfData, setPdfData] = useState("");
  const [pdfFileName, setPdfFileName] = useState("report.pdf");
  const [isPdfLoading, setIsPdfLoading] = useState(false);

  const handleNotify = () => {
    let hiuId = "LPL";
    let name = raw?.first_name + " " + raw?.last_name;
    let payload = {
      authMode: "DEMOGRAPHICS",
      purpose: "KYC_AND_LINK",
      type: "HIU",
      phrId: `${raw?.abha_address}`,
      referenceType: "Consent Request",
      lplLinkReference: `${raw?.abha_address || ""}`,
      platform: `${raw?.platform || "website"}`,
      platformType: `${raw?.platform_type || "creat abha page"}`,
      patientReference: `${raw?.patinet_id || ""}`,
      careContextReference: `${raw?.lab_number || ""}`,
      version: "v1",
      reportDateTime: `${raw?.report_date_time || ""}`,
      query: {
        id: `${raw?.abha_address || ""}`,
        purpose: "KYC_AND_LINK",
        requester: {
          type: "HIU",
          id: hiuId || ""
        },
        demographic: {
          name: `${name || ""}`,
          mobile_no: `${raw?.mobile_number || ""}`,
          gender: `${raw?.gender || ""}`,
          dateOfBirth: `${raw?.dob || ""}`
        }
      }
    };

    let _data = { ...payload };
    _data.customToken = true;
    // console.log(_data)
    // return false
    Notify(_data);
  };

  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const onChange = (value, dateString) => {
    // console.log('Selected Time: ', value);
    // console.log('Formatted Selected Time: ', dateString);
  };
  const onOk = (value) => {
    // console.log('onOk: ', value);
  };
  useEffect(() => {
    AbhaServices.ReportList({ ...filter, currentPage, limit }, dispatch);
    return () => {};
  }, [filter, limit, page, currentPage]);
  // console.log(abhaCreatedList?.setRaw);
  const handleViewReport = async (e, report) => {
    e.preventDefault();
    setIsPdfLoading(true);
    try {
      const response = await Api.post(API_URL.GET_REPORT_PDF, {
        ReportId: encryptedData(report?.id),
        UserId: LOG_IN_USER?.UserId
      });
      const base64Pdf = response?.data?.result;
      if (base64Pdf) {
        setPdfData(base64Pdf);
        setPdfFileName(`report_${report?.lab_number || report?.id || Date.now()}.pdf`);
        setPdfModalVisible(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsPdfLoading(false);
    }
  };

  const handleDownloadPdf = () => {
    if (!pdfData) return;
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${pdfData}`;
    link.download = pdfFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const closePdfModal = () => {
    setPdfModalVisible(false);
    setPdfData("");
    setPdfFileName("report.pdf");
  };

  useEffect(() => {
    if (abhaCreatedList && abhaCreatedList.length > 0) {
      var data = [];
      abhaCreatedList.forEach((value, index) => {
        var item = {
          sno: value?.sno,
          log_type: value?.log_type,
          first_name: value?.first_name,
          last_name: value?.last_name,
          mobile_number: value?.mobile_number,
          heathid_no: value?.heathid_no,
          abha_address: value?.abha_address,
          lab_number: value?.lab_number,
          facility_id: value?.facility_id,
          facility_name: value?.facility_name,
          is_linked: value?.is_linked,
          report_date_time: value?.report_date_time,
          createdAt: value?.createdAt
        };

        data.push(item);
      });
      setFilteredData(data);
    }
    return () => {};
  }, [abhaCreatedList]);

  const headers = [
    { label: "S.No.", key: "sno" },
    { label: "Patient Name", key: "first_name" },
    { label: "ABHA Address", key: "abha_address" },
    { label: "Mobile Number", key: "mobile_number" },
    { label: "Lab Number", key: "lab_number" },
    { label: "Facility ID", key: "facility_id" },
    { label: "Facility Name", key: "facility_name" },
    { label: "Status", key: "is_linked" },
    { label: "Report Date and Time", key: "report_date_time" },
    { label: "Created Date Time", key: "createdAt" }
  ];

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * limit + index + 1
    },
    // {
    //     title: 'Link and Notify',
    //     dataIndex: 'is_linked',
    //     key: 'action',
    //     className: 'abha-link-action',
    //     render: (value, record,index) => {
    //         // return (
    //         //     <> <Tooltip placement="top" title={"Link & Notify"}>
    //         //         <Button className="view-btn" type="primary" onClick={() => { setRaw(item || {}); setModalNotify(true);  }}><LinkOutlined /></Button>
    //         //     </Tooltip>
    //         //        </>
    //         // )
    //         return (record?.is_linked) ?
    //             ''
    //             : <Tooltip placement="top" title={"Link & Notify"}>
    //             <Button className="view-btn" type="primary" onClick={() => { setRaw(record || {}); setModalNotify(true); }}><LinkOutlined /></Button>
    //       </Tooltip>

    //     }
    // },
    {
      title: "Patient Name",
      dataIndex: "id",
      key: "id",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <span>
            {item?.first_name} {item?.middle_name} {item?.last_name}
          </span>
        );
      }
    },
    {
      title: "Doc Type",
      dataIndex: "report_type",
      key: "log_type",
      className: "table_status_col",
      name: "type"
    },
    {
      title: "ABHA Address",
      dataIndex: "abha_address",
      key: "log_type",
      className: "table_status_col",
      name: "type"
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "id",
      className: "text-capitalize"
    },

    {
      title: "Lab Number",
      dataIndex: "lab_number",
      key: "request_url",
      className: "table_status_col"
    },
    {
      title: "Visit ID",
      dataIndex: "visit_id",
      key: "visit_id",
      className: "table_status_col"
    },
    {
      title: "Report Date and Time",
      dataIndex: "requestor",
      key: "requestor",
      className: "w-200",
      render: (value, item, index) => {
        return (
          <span>
            <>
              {item?.report_date_time
                ? moment(item.report_date_time).format("DD-MMM-YYYY hh:mm A")
                : "-"}
            </>
          </span>
        );
      }
    },
    {
      title: "Status",
      dataIndex: "raw_data",
      key: "raw_data",
      className: "table_status_col patient",
      render: (value, item, index) => {
        return (
          <span
            className={item?.is_linked ? "status_linked" : "status_pending"}
          >
            {item?.is_linked ? "Linked" : "Pending"}
          </span>
        );
      }
    },
    {
      title: "Report URL",
      dataIndex: "heathid_no",
      key: "health_id",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            {item?.pdf_url && (
              <a href="#" onClick={(e) => handleViewReport(e, item)}>
                View Report
              </a>
            )}
          </span>
        );
      }
    },
    // {
    //     title: 'ABHA Address',
    //     dataIndex: 'health_id',
    //     key: 'health_id',
    //     width: 200
    // },

    {
      title: "Facility ID",
      dataIndex: "facility_id",
      key: "facility_id",
      render: (value) => value || "-"
    },
    {
      title: "Facility Name",
      dataIndex: "facility_name",
      key: "facility_name",
      render: (value) => value || "-"
    },
    {
      title: "Created Date Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "abha-link-date",
      render: (value, item, index) => {
        return <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>;
      }
    }
    // {
    //     title: 'Requested Data',
    //     dataIndex: 'action',
    //     key: 'action',
    //     className: 'table_status_col',
    //     render: (value, item, index) => {
    //         return (
    //             <><Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.raw_data || "{}")); setModal1Open(true); }}> View</Button>
    //             </>
    //         )

    //     }
    // },
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col span={24}>
          <HeadingBack
            title={"Care Context"}
            subHeading={`Records ${totalAbhaReportsLogs}`}
          />
        </Col>
        <Col span={24}>
          <ReportFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            headers={headers}
            FilteredData={FilteredData}
            setFilteredData={setFilteredData}
          />
        </Col>
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey="id"
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          // Columns size to their content; wide tables scroll sideways
          scroll={{ x: "max-content" }}
          bordered
          columns={columns}
          dataSource={
            Array.isArray(abhaCreatedList) && abhaCreatedList?.length > 0
              ? abhaCreatedList
              : []
          }
          pagination={{
            current: currentPage,
            pageSize: limit,
            total: totalAbhaReportsLogs,
            onChange(current, pageSize) {
              setPage(current);
              setCurrentPage(current);
            },
            hideOnSinglePage: true
            /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
          }}
        />
        <Modal
          style={{
            top: 20
          }}
          open={ModalNotify}
          onOk={() => {
            handleNotify();
            setModalNotify(false);
          }}
          onCancel={() => setModalNotify(false)}
          okText="Yes"
        >
          <h3>Are sure want to link and notify to user?</h3>
        </Modal>
      </div>      <Modal
        title="Report Preview"
        open={pdfModalVisible}
        onCancel={closePdfModal}
        footer={[
          <Button key="close" onClick={closePdfModal}>
            Close
          </Button>,
          <Button
            key="download"
            type="primary"
            onClick={handleDownloadPdf}
            disabled={!pdfData}
          >
            Download
          </Button>
        ]}
        width={1000}
        style={{ top: 10 }}
        bodyStyle={{ padding: 0, minHeight: "calc(100vh - 120px)" }}
        destroyOnClose
      >
        {isPdfLoading ? (
          <div className="text-center p-4">Loading report...</div>
        ) : pdfData ? (
          <iframe
            title="Report PDF"
            src={`data:application/pdf;base64,${pdfData}`}
            style={{ width: "100%", height: "calc(100vh - 180px)", border: "none" }}
          />
        ) : (
          <div className="text-center p-4">Unable to load report preview.</div>
        )}
      </Modal>    </div>
  );
};

export default ReportList;
